import {Component, inject, input} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {Router} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {TitleCasePipe} from '@angular/common';
import {Category} from '@core/models';
import {CatalogStore} from '@store/catalog.store';

@Component({
  selector: 'app-category-card',
  standalone: true,
  imports: [
    MatCardModule,
    TitleCasePipe,
    MatIconModule
  ],
  template: `
    <div (click)="goToCategory(category().categoryId)" class="category-card mat-z-elevation-14">
      @if (category().isNew) {
        <span class="item-ribbon ribbon-new">NUEVO</span>
      }
      @if (category().comingSoon) {
        <span class="item-ribbon ribbon-soon">PRONTO</span>
      }
      <div class="image-wrapper">
        <img [alt]="category().description"
             [src]="category().imageUrl"
             class="category-card-image"
             loading="lazy">
        <div class="category-card-overlay"></div>
      </div>
      <div class="category-info">
        <span class="category-name">{{ (category().name || category().description) | titlecase }}</span>
        <span class="category-count">{{ category().products?.length || 0 }} productos</span>
      </div>
      <div class="category-arrow">
        <mat-icon>chevron_right</mat-icon>
      </div>
    </div>
  `,
  styleUrl: './category-card.scss',
})
export class CategoryCard {
  category = input<Partial<Category>>({name: '', imageUrl: ''});
  private store = inject(CatalogStore);
  private router = inject(Router);

  goToCategory(id: number | undefined) {
    if (!id) return;
    this.store.allProducts(id);
    this.router.navigate(['/standard/menu', id], {replaceUrl: true});
  }
}
